/* eslint-disable max-classes-per-file */

import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { DateUtils } from "~app/common/utils/date-utils";

export class MigrateVirkeskopskontraktToViol3Command extends BasicCommand<MigrateVirkeskopskontraktToViol3Command> {
    get primaryKey() {
        return {
            kontraktnummer: this.kontraktnummer
        };
    }
    kontraktnummer: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "MigrateVirkeskopskontraktToViol3Command";
    constructor(init: (instance: MigrateVirkeskopskontraktToViol3Command) => void) {
        super("MigrateVirkeskopskontraktToViol3Command", "Kontraktmigrering", CommandType.Replace);
        init(this);
    }
}

export class KontraktsmigreringRowVm {
    kontraktnummer: string;
    viol3: string;
    status: string;
    tidpunkt: string;
    meddelande: string;
    isModified = false;
    log: string;

    static createNew(kontraktnummer: string) {
        const row = new KontraktsmigreringRowVm();
        row.status = KontraktsmigreringStatusar.ny;
        row.isModified = true;
        row.kontraktnummer = kontraktnummer;
        row.tidpunkt = DateUtils.formatDateString(new Date(), DateUtils.datetimeformatWithoutMillis);
        return row;
    }

    static createFromDto(kontraktnummer: string,
        status: string,
        tidpunkt: string,
        viol3: boolean,
        meddelande: string,
        log: string) {
        const row = new KontraktsmigreringRowVm();
        row.kontraktnummer = kontraktnummer;
        row.viol3 = viol3 ? "Ja" : "Nej";
        row.status = status;
        row.tidpunkt = tidpunkt;
        row.meddelande = meddelande;
        row.log = log;
        return row;
    }

    enqueue(): void {
        this.status = KontraktsmigreringStatusar.ny;
        this.setModified();
    }

    setModified() {
        this.meddelande = null;
        this.log = null;
        this.isModified = true;
        this.tidpunkt = DateUtils.formatDateString(new Date(), DateUtils.datetimeformatWithoutMillis);
    }

    setPristine(): void {
        this.isModified = false;
    }
}

export class KontraktsmigreringStatusar {
    static readonly ny = "Ny";
    static readonly fel = "Fel";
    static readonly ok = "OK";
}
